<template>
    <v-container>
    <h2 class="text-h4 mb-3">{{ $t('billing.title') }}</h2>
    
    <v-card v-if="item && item.hasStripeSubscription"  class="mb-3">
    <v-card-title>
        {{ $t('billing.customerPortal.title') }}
        
    </v-card-title>
    <v-card-text>
    {{$t('billing.customerPortal.text')}}
    </v-card-text>
    <v-card-actions>
    <v-btn text color="primary" @click="goToPortal">{{ $t('billing.customerPortal.action') }}</v-btn>
    </v-card-actions>
    </v-card>
    <v-card v-if="item && !item.hasStripeSubscription && !isTrial" class="mb-3">
       <v-card-title>{{ $t('billing.noSubscription.title') }}</v-card-title>
       <v-card-text> {{ $t('billing.noSubscription.text') }}</v-card-text>
       <v-card-actions>
           <v-btn
                text
                :to="{name: 'plan'}"
                color="primary"
            >
            {{ $t('companies.selectPlan')}}
            </v-btn>
       </v-card-actions>
    </v-card>
    <v-card v-if="item && !item.hasStripeSubscription && isTrial" class="mb-3">
       <v-card-title>{{ $t('billing.trial.title') }}</v-card-title>
       <v-card-text>{{ $t('billing.trial.text') }}</v-card-text>
       <v-card-actions>
           <v-btn
                text
                :to="{name: 'plan'}"
                color="primary"
            >
            {{ $t('companies.selectPlan')}}
            </v-btn>
       </v-card-actions>
    </v-card>

    <v-card v-if="item && item.activeSubscription" class="mb-3">
        <v-card-title>{{ $t('billing.currentPeriod.title') }}</v-card-title>
        <v-card-text>{{ $t('billing.currentPeriod.text') }}</v-card-text>
        <v-list>
              <v-list-item>
                <v-list-item-icon><v-icon>$calendarFrom</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('common.intervals.from')}}</v-list-item-subtitle>
                  <v-list-item-title> {{ formatDate(item.activeSubscription.from) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$calendarTo</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('common.intervals.to')}}</v-list-item-subtitle>
                  <v-list-item-title> {{ formatDate(item.activeSubscription.to) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-icon><v-icon>$visitors</v-icon></v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-subtitle>{{$t('companies.visitors')}}</v-list-item-subtitle>
                  <v-list-item-title><span :class="getVisitorsColor(item.stats.monthlyUsers, item.activeSubscription.monthlyUserLimit)">{{item.stats.monthlyUsers}}</span> / {{ (item.activeSubscription.monthlyUserLimit) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
        </v-list>
        
    </v-card>

    
    <v-card v-if="item" :loading="loading">
        <v-card-title>{{ $t('billing.history.title') }}</v-card-title>
        <v-data-table :headers="headers" :items="item.history" v-if="item.history">
             <template #item.subscription.from="{ item }">
                {{ formatDate(item.subscription.from) }}
            </template>
             <template #item.subscription.to="{ item }">
                {{ formatDate(item.subscription.to) }}
            </template>
            
        </v-data-table>
        <v-skeleton-loader type="table" v-else />
    </v-card>
    <template v-if="!item">
    <v-skeleton-loader type="card" class="mb-3" v-for="i in 3" :key="i">
    </v-skeleton-loader>
    </template>
    </v-container>
</template>
<script>

import { mapState, mapGetters } from "vuex";
import Formatters from "@/mixins/formatters"

export default {
    mixins: [Formatters],
    name: 'Billing',
    data() {
        return {
            loading: false,
            headers: [
                { text: this.$t('common.intervals.from'), value: 'subscription.from' },
                { text: this.$t('common.intervals.to'), value: 'subscription.to'},
                { text: this.$t('billing.visitorLimit'), value: 'subscription.monthlyUserLimit'},
                { text: this.$t('billing.consumedVisits'), value: 'stats.monthlyUsers'},
                { text: this.$t('billing.sales'), value: 'stats.dreamroiSales'},
                { text: this.$t('billing.emails'), value: 'stats.emailsSent'},
            ]
        }
    },
    computed: {
        ...mapState('companies', ['item']),
        ...mapGetters('companies', ['isTrial'])
    },
    watch: {
        item(val, oldVal) {
            if(!val) {
                return;
            }
            if(!oldVal || oldVal?.id != val?.id || !val.history) {
                this.getHistory();
            } 
        }
    },
    methods: {
        async goToPortal() {
            if(!this.item) {
                return;
            }
            let url = await this.$store.dispatch('companies/getStripePortalLink', { id: this.item.id });
            console.debug(url);
            window.location.assign(url);
        },
        async getHistory() {
            this.loading = true;
            await this.$store.dispatch('companies/getBillingHistory', { id: this.item.id });
            this.loading = false;
        }
    },
    created() {
        if(this.item) {
            this.getHistory();
        }
    }
}
</script>